export const getState = store => store.api;

export const getUnauthorized = store => getState(store).get('unauthorized');
export const getServerError = store => getState(store).get('serverError');
export const getNotFound = store => getState(store).get('notFound');
export const getConnectionError = store => getState(store).get('connectionError');
export const getSuccess = store =>
  !getUnauthorized(store) && !getServerError(store) && !getNotFound(store) && !getConnectionError(store);
export const getForbidden = store => getState(store).get('forbidden');
